<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-19 14:57:19
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-19 14:57:48
-->
<template>
    <router-view />
</template>

<script>
export default {
	name: 'InsureView',
};
</script>